/**
 * Map English weekday names to translation keys
 * Keys are in calendar namespace (calendar.weekdays.monday, etc.)
 */
export const WEEKDAY_TO_KEY_MAP: Record<string, string> = {
    Monday: "weekdays.monday",
    Tuesday: "weekdays.tuesday",
    Wednesday: "weekdays.wednesday",
    Thursday: "weekdays.thursday",
    Friday: "weekdays.friday",
    Saturday: "weekdays.saturday",
    Sunday: "weekdays.sunday",
} as const;

/**
 * Map English short month names to translation keys
 */
export const MONTH_SHORT_TO_KEY_MAP: Record<string, string> = {
    Jan: "januaryShort",
    Feb: "februaryShort",
    Mar: "marchShort",
    Apr: "aprilShort",
    May: "mayShort",
    Jun: "juneShort",
    Jul: "julyShort",
    Aug: "augustShort",
    Sep: "septemberShort",
    Oct: "octoberShort",
    Nov: "novemberShort",
    Dec: "decemberShort",
} as const;

/**
 * Map English full month names to translation keys
 */
export const MONTH_FULL_TO_KEY_MAP: Record<string, string> = {
    January: "january",
    February: "february",
    March: "march",
    April: "april",
    May: "may",
    June: "june",
    July: "july",
    August: "august",
    September: "september",
    October: "october",
    November: "november",
    December: "december",
} as const;

/**
 * Convert English weekday name to translation key
 * @param weekdayName - English weekday name (e.g., "Monday")
 * @returns Translation key (e.g., "weekdays.monday") for use with calendar namespace or original string if not found
 */
export function getWeekdayTranslationKey(weekdayName: string): string {
    return WEEKDAY_TO_KEY_MAP[weekdayName] || weekdayName;
}

/**
 * Convert English month name (short or full) to translation key
 * @param monthName - English month name (e.g., "Jan" or "January")
 * @returns Translation key (e.g., "januaryShort" or "january") or original string if not found
 */
export function getMonthTranslationKey(monthName: string): string {
    return MONTH_SHORT_TO_KEY_MAP[monthName] || MONTH_FULL_TO_KEY_MAP[monthName] || monthName;
}
